import React from 'react';

import About from './About/AboutContainer';
import Methodology from './Methodology/MethodologyContainer';
import Reviews from './Reviews/ReviewsContainer';
import Courses from './Courses/CoursesContainer';
import Blog from './Blog/BlogContainer';


const Home = () => {
  return (
    <div className="home fade-in">
      <About />
      <Methodology />
      <Reviews />
      <Courses />
      <Blog />
    </div>
  );
};


export default Home;


// WEBPACK FOOTER //
// ./src/components/Home/Home.js